import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import i18n from '@/pages/design/locale/i18n';
import YYImage from "@/pages/design/components/basic/image";
export default {
  name: "commodity",
  i18n: require('./commodity_i18n'),
  props: {
    item: Object,
    index: Number,
    type: {
      //1表示我的收藏页面样式，2表示其他页面样式
      type: [Number, String],
      default: 2
    }
  },
  components: {
    YYImage: YYImage
  },
  data: function data() {
    return {
      //积分
      //reward_points: this.$t('my_collection.reward_points'),

      //库存紧张
      productStockStatus: this.$t('my_collection.productStockStatus'),
      //处分品
      disposals: this.$t('my_collection.disposals'),
      //满减
      full_minus: this.$t('my_collection.full_minus'),
      //满折券
      full_discount_coupon: this.$t('my_collection.full_discount_coupon'),
      //满减券
      full_coupon_reduction: this.$t('my_collection.full_coupon_reduction'),
      //包邮券
      parcel_post_voucher: this.$t('my_collection.parcel_post_voucher'),
      //补货中
      replenishment: this.$t('my_collection.replenishment'),
      //金额单位
      rightSymbol: window.localStorage.rightCurrencySymbol,
      systemInfo: false,
      i18n: i18n
    };
  },
  watch: {
    item: function item(res) {
      this.handleData();
    }
  },
  beforeMount: function beforeMount() {
    this.handleData();
  },
  created: function created() {
    var defaultLangObjStr = window.localStorage.cdefaultLangObj ? window.localStorage.cdefaultLangObj : window.localStorage.defaultLangObj;
    var defaultLangObj = JSON.parse(defaultLangObjStr);
    // let defaultLangObj = JSON.parse(localStorage.defaultLangObj)
    if (defaultLangObj) {
      this.defaultLangId = defaultLangObj.langId;
    }
    var lang = localStorage.langCode;
    this.i18n.locale = lang;
    this.$t = this.i18n.t.bind(this.i18n);
  },
  methods: {
    //处理数据，优惠卷标签
    handleData: function handleData() {
      var _this = this;
      if (this.item.couponTypeList) {
        this.item.couponTypeList.forEach(function (i) {
          //优惠券类型（"1：满减券   2：满折券  3：包邮券"）
          if (i == 1) {
            _this.item.bottom_last_row_tag3 = true; //满减券
          } else if (i == 2) {
            _this.item.bottom_last_row_tag2 = true; //满折券
          } else if (i == 3) {
            _this.item.bottom_last_row_tag4 = true; //包邮券
          }
        });
      }
    },
    //取消收藏
    cancel: function cancel() {
      // alert('取消收藏')

      // this.List.splice(index,1)
      this.$emit('cancel', {
        item: this.item,
        index: this.index
      });
    },
    //加入购物车
    addCart: function addCart() {
      this.$addCart(this.item.productNo, 1);
    }
  }
};